import { Sparkle } from "lucide-react";
import { TICKER } from "@/data/site";

export const Ticker = () => {
  const row = [...TICKER, ...TICKER, ...TICKER, ...TICKER];
  return (
    <div data-testid="top-ticker" className="h-9 overflow-hidden bg-[#08080a]/90 backdrop-blur-xl border-b border-white/10 flex items-center">
      <div className="flex w-max ticker-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center gap-6 px-3 font-display text-[11px] font-semibold tracking-[0.16em] uppercase text-slate-200 whitespace-nowrap">
            {w}
            <Sparkle className="h-3 w-3 text-[#d5d9df] fill-[#d5d9df]" />
          </span>
        ))}
      </div>
    </div>
  );
};
